import dayjs from "dayjs";
import { Stack } from "@altimateai/lego";
import { BiReport } from "@/pages/biReports/types";

interface DashboardMetadataProps {
  dashboardDetails: BiReport;
}

export const DashboardMetadata = ({ dashboardDetails }: DashboardMetadataProps) => {
  return (
    <Stack gap="md" wrap>
      <Stack align="center" gap="xs">
        <dt id="project-name-label" className="al-text-sm al-text-gray-700 al-font-medium">
          Project Name:
        </dt>
        <dd aria-labelledby="project-name-label" className="al-text-sm al-text-gray-500">
          {dashboardDetails.project_name}
        </dd>
      </Stack>
      <Stack align="center" gap="xs">
        <dt id="workbook-name-label" className="al-text-sm al-text-gray-700 al-font-medium">
          Workbook Name:
        </dt>
        <dd aria-labelledby="workbook-name-label" className="al-text-sm al-text-gray-500">
          {dashboardDetails.workbook}
        </dd>
      </Stack>
      <Stack align="center" gap="xs">
        <dt id="worksheets-label" className="al-text-sm al-text-gray-700 al-font-medium">
          Worksheets:
        </dt>
        <dd aria-labelledby="worksheets-label" className="al-text-sm al-text-gray-500">
          {dashboardDetails.worksheet_count}
        </dd>
      </Stack>
      <Stack align="center" gap="xs">
        <dt id="total-users-label" className="al-text-sm al-text-gray-700 al-font-medium">
          Total Users:
        </dt>
        <dd aria-labelledby="total-users-label" className="al-text-sm al-text-gray-500">
          {dashboardDetails.user_count}
        </dd>
      </Stack>
      <Stack align="center" gap="xs">
        <dt id="last-viewed-label" className="al-text-sm al-text-gray-700 al-font-medium">
          Last Viewed:
        </dt>
        <dd aria-labelledby="last-viewed-label" className="al-text-sm al-text-gray-500">
          {dayjs(dashboardDetails.last_viewed).format("MMM D, YYYY, h:mm A")}
        </dd>
      </Stack>
      <Stack align="center" gap="xs">
        <dt id="owner-label" className="al-text-sm al-text-gray-700 al-font-medium">
          Owner:
        </dt>
        <dd aria-labelledby="owner-label" className="al-text-sm al-text-gray-500">
          {dashboardDetails.owner}
        </dd>
      </Stack>
    </Stack>
  );
};
